import React from 'react';

import Button from '../../components/buttons/Button';
import TextInput from '../../components/form/TextInput';
import Dialog from '../../components/alert/Dialog';
import STRINGS from './../../data/language/language';
import ProblemaItem from './ProblemaItem';

const PROBLEMAS = {
  cardiaco: 'Problemas cardíacos',
  renais: 'Problemas renais',
  diabetes: 'Diabetes',
  ombros: 'Dor nos ombros',
  coluna: 'Dor na coluna',
  joelhos: 'Dor nos joelhos',
  semLimitacao: 'Não possuo limitação'
};

const PROBLEMAS_OUTROS = 'problemasOutros';
const PROBLEMAS_ADICIONADOS = 'problemasAdicionados';

class FormProblemas extends React.Component{
  constructor(props){
    super(props);

    const cardiaco = this.getProblemasProps(PROBLEMAS.cardiaco);
    const renais = this.getProblemasProps(PROBLEMAS.renais);
    const diabetes = this.getProblemasProps(PROBLEMAS.diabetes);
    const joelhos = this.getProblemasProps(PROBLEMAS.joelhos);
    const coluna = this.getProblemasProps(PROBLEMAS.coluna);
    const ombros = this.getProblemasProps(PROBLEMAS.ombros);
    const semLimitacao = this.getProblemasProps(PROBLEMAS.semLimitacao);

    const adicionados = this.getProblemasAdd().adicionados;
    const outros = this.getProblemasAdd().outros;

    this.state = {
      cardiaco,
      renais,
      diabetes,
      joelhos,
      coluna,
      ombros,
      semLimitacao,
      problemasAdicionados: adicionados,//problemas dos checkboxes
      problemasOutros: outros,//outros problemas adicionados
      strings: STRINGS[window.LANGUAGE]
    };

    this.addProblema(adicionados, PROBLEMAS_ADICIONADOS);
    this.addProblema(outros, PROBLEMAS_OUTROS);

    this.handleInputChange = this.handleInputChange.bind(this);
    this.changeStep = this.changeStep.bind(this);
    this.addProblemaOutro = this.addProblemaOutro.bind(this);
    this.onRemoveProblema = this.onRemoveProblema.bind(this);
  }

  getProblemasAdd() {
    const obj = {};
    obj.adicionados = [];
    obj.outros = [];

    this.props.problemas.map((value,i)=>{
      switch(value){
        case PROBLEMAS.cardiaco:
        case PROBLEMAS.renais:
        case PROBLEMAS.diabetes:
        case PROBLEMAS.joelhos:
        case PROBLEMAS.coluna:
        case PROBLEMAS.ombros:
        case PROBLEMAS.semLimitacao:
          obj.adicionados.push(value);
        break;
        default:
          obj.outros.push(value);
        break;
      }
    });

    return obj;
  }

  getProblemasProps(valueCheck){
    let doenca = '';

    this.props.problemas.map((value,i)=>{
      if(value === valueCheck){
        doenca = true;
      }
    });

    return doenca;
  }


  handleInputChange(event){
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    const nomeProblema = PROBLEMAS[name];

    //-----
    //checa o array dos problemas
    let problema;
    const array = [...this.state[PROBLEMAS_ADICIONADOS]];

    for(let i=0; i<array.length; i++){
      const item = array[i];
      //caso o nome do problema for o do array problemasAdicionados salvamos o index do item
      if(nomeProblema === item){
        //convertemos em string pois se o index for 0 é como se ele não existisse
        problema = String(i);
      }
    }

    if(problema){
      //se o problema já existir no array o removemos
      array.splice(problema, 1);
    }else{
      array.push(nomeProblema);
    }
    //-----

    this.setState({
      [name]: value,
      problemasAdicionados: array
    });

    this.addProblema(array, PROBLEMAS_ADICIONADOS);
  }

  onRemoveProblema(index) {
    const array = this.state[PROBLEMAS_OUTROS];
    array.splice(index, 1);

    this.setState({
      problemas: array
    });

    this.setProblemas(array);
  }

  //adiciona um outro problema
  addProblemaOutro(e){
    const problema = document.getElementById('input-problema');
    const value = problema.value;
    const arr = [...this.state.problemasOutros, value];
    problema.value = '';

    this.setProblemas(arr);

    e.preventDefault();
  }

  setProblemas(arr) {
    this.setState({
      problemasOutros: arr
    });

    this.addProblema(arr, PROBLEMAS_OUTROS);
  }

  addProblema(arr, type) {
    const prob =
          PROBLEMAS_OUTROS === type ?
            this.state[PROBLEMAS_ADICIONADOS] :
            this.state[PROBLEMAS_OUTROS];
    let problemasTemp = [...prob, ...arr];
    this.props.changeProblemas(problemasTemp);
  }

  changeStep(step) {
    this.props.changeStep({ step:step });
  }

  getProblemas(){
    const arr = this.state.problemasOutros.map((value,i)=>{
      return <ProblemaItem
        onRemove={()=>{this.onRemoveProblema(i)}}
        key={i}
        value={value}
        index={i}
      />;
    });

    return arr;
  }

  render(){
    const strings = this.state.strings;
    const problemas = this.getProblemas();

    return(
      <div  className='box-formulario-problemas'>
        <div className='box-title  pure-u-1'>
          {/*<span className='cadastro-title'><strong>Cadastro - </strong>1 de 3</span>*/}
          <span className=''>{strings.problemasSaude}</span>
        </div>
        <div>
          <div>
            <div className="pure-u-md-1-2 pure-u-1 problema-item">
              <input
                name="semLimitacao"
                type="checkbox"
                checked={this.state.semLimitacao}
                onChange={this.handleInputChange}
              />
                <span className='type-pay-txt'>{strings.nenhumProblema}</span>
            </div>
            <div className="pure-u-md-1-2 pure-u-1 problema-item">
              <input
                name="cardiaco"
                type="checkbox"
                checked={this.state.cardiaco}
                onChange={this.handleInputChange}
              />
                <span className='type-pay-txt'>{strings.cardiaco}</span>
            </div>
            <div className="pure-u-md-1-2 pure-u-1 problema-item">
              <input
                name="renais"
                type="checkbox"
                checked={this.state.renais}
                onChange={this.handleInputChange}
              />
                <span className='type-pay-txt'>{strings.renais}</span>
            </div>
            <div className="pure-u-md-1-2 pure-u-1 problema-item ">
              <input
                name="diabetes"
                type="checkbox"
                checked={this.state.diabetes}
                onChange={this.handleInputChange}
              />
                <span className='type-pay-txt'>{strings.diabetes}</span>
            </div>
            <div className="pure-u-md-1-2 pure-u-1 problema-item ">
              <input
                name="joelhos"
                type="checkbox"
                checked={this.state.joelhos}
                onChange={this.handleInputChange}
              />
                <span className='type-pay-txt'>{strings.joelhos}</span>
            </div>
            <div className="pure-u-md-1-2 pure-u-1 problema-item ">
              <input
                name="coluna"
                type="checkbox"
                checked={this.state.coluna}
                onChange={this.handleInputChange}
              />
                <span className='type-pay-txt'>{strings.coluna}</span>
            </div>
            <div className="pure-u-md-1-2 pure-u-1 problema-item">
              <input
                name="ombros"
                type="checkbox"
                checked={this.state.ombros}
                onChange={this.handleInputChange}
              />
                <span className='type-pay-txt'>{strings.ombros}</span>
            </div>
            <div className='txtProblemas pure-u-1'>{strings.outrosProblemas}</div>
            <div className='box-insert-problema pure-u-1'>
              <div className='input-problema pure-u-18-24'>
                <span>
                  <input id='input-problema' name='problema' placeholder={strings.digiteProblema} />
                </span>
              </div>
              <div className='pure-u-4-24'>
                <a href='#' className='bt-adicionar-problema ' onClick={this.addProblemaOutro}>Adicionar</a>
              </div>
              <div className='obsProblema'><p>{strings.obsProblema}</p></div>
            </div>
            <div>
              {problemas}
            </div>
          </div>
          <br />

        </div>
      </div>
    )
  }
}


export default FormProblemas;



// WEBPACK FOOTER //
// ./src/classes/perfil/FormProblemas.js